/**
* File browser to view entire member folder structure under the Googe Drive
*
* Created by Paul on 20/06/2020
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import cx from 'classnames'

// action import
import { ActionCreator } from '../../actions/'

import { faFolder, faFolderOpen, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Material-UI
import { withStyles } from '@material-ui/styles'
import IconButton from '@material-ui/core/IconButton'
import CloudDownloadIcon from '@material-ui/icons/GetAppTwoTone'
import Chip from '@material-ui/core/Chip'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Collapse from '@material-ui/core/Collapse'

import moment from 'moment'

// style import
import './style.scss'

const styles = ({
    downloadIcon: {
        color: "#4638D0",
        opacity: 0.85,
        outline: 'none!important',
        padding: 10,
        '&:hover': {
            opacity: 1,
        },
        marginRight: 5,
    },
    categoryChip: {
        fontFamily: 'Montserrat',
        border: '0px solid #4638D0',
        borderRadius: 0,
        color: '#fff',
        //opacity: 0.8,
        background: 'rgba(70, 56, 208, 0.85)',
        fontSize: 10,
        height: 19,
    },
})


class FileBrowser extends Component {

    constructor(props) {
        super(props)

        this.state = {
            open: []
        }
    }

    handleClick = (val) => {
        let prevOpen = this.state.open
        let index = this.state.open.indexOf(val)

        if (index === -1) {
            prevOpen.push(val)
        }
        else {
            prevOpen.splice(index, 1)
        }

        this.setState({ open: prevOpen })
    }

    renderDocument(item, index, indent) {
        
        const { classes, docSignStatus, member_id } = this.props

        // Check if DocuSign vs Google Documents
        if (item.id) {
            
            //const primaryStatus = docSignStatus.primary_recipient_status
            item['uri'] = `${process.env.REACT_APP_WEBSITE_URL}/api/document/${item.id}/adviser-download/${member_id}`

            //if (primaryStatus === "completed") {
                item['category'] = 'eSigned'
            //}
            //else {
            //    item['category'] = 'eSigning in Progress'
            //}
        }
        else {
            item['uri'] = `${process.env.REACT_APP_WEBSITE_URL}/api/member-documents/download/${item.key}`
        }

        let moment_date = moment(item['created_date'])

        return (
            <tr key={index} className="row">
                <td width="50%" className="data-cell">
                    <div className={indent ? 'indent' : ''}>
                        <div className="file">
                            { item.name }
                        </div>
                    </div>
                </td>
                <td width="20%" className="data-cell"><span className="details">{ moment_date.fromNow() }</span></td>
                <td width="20%" className="data-cell">
                    <span className="details">{ item.category && <Chip className={classes.categoryChip} variant="outlined" size="small" label={ item.category } />}</span>
                </td>
                <td className="data-cell action-cell" width="10%">
                    <IconButton aria-label="download" className={ classes.downloadIcon } target="_blank" href={ item.uri }>
                        <FontAwesomeIcon className="download-icon" icon={faDownload} />
                    </IconButton>
                </td>
            </tr>
        )
    }

    renderDocumentFolder(item, index) {
        const { classes } = this.props

        return (
            <React.Fragment key={index}>
                <tr className="row row--folder" onClick={ ()=> this.handleClick(item.name) }>
                    <td className="folder-cell">
                        <div className="icon">
                            { this.state.open.includes(item.name) ? <FontAwesomeIcon icon={faFolderOpen} /> : <FontAwesomeIcon icon={faFolder} /> }
                        </div>
                        <div className="folder">
                            FY { item.name }
                        </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td className="action-cell">
                        {/*<IconButton aria-label="expand" className={classes.downloadIcon}>
                             this.state.open.includes(item.name) ? <ExpandLess /> : <ExpandMore />
                        </IconButton>*/}
                    </td>
                </tr>
                <tr>
                    <td colSpan="4" className="hidden-cell">
                        <Collapse in={ this.state.open.includes(item.name) } timeout="auto" unmountOnExit>
                            <table cellSpacing="0" cellPadding="0">
                                <tbody>
                                    { item.files.map((file, i) => this.renderDocument(file, i, true)) }
                                </tbody>
                            </table>
                        </Collapse>
                    </td>
                </tr>
            </React.Fragment>
        )
    }

    renderEnvelope(item, index) {
        const { classes, envelope } = this.props
        
        return (
            <React.Fragment key={index}>
                <tr className="row row--folder" onClick={ ()=> this.handleClick(item.name) }>
                    <td className="folder-cell">
                        <div className="icon">
                            { this.state.open.includes(item.name) ? <FontAwesomeIcon icon={faFolderOpen} /> : <FontAwesomeIcon icon={faFolder} /> }
                        </div>
                        <div className="folder">
                            { item.name }
                        </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td className="action-cell"></td>
                </tr>
                <tr>
                    <td colSpan="4" className="hidden-cell">
                        <Collapse in={ this.state.open.includes(item.name) } timeout="auto" unmountOnExit>
                            <table cellSpacing="0" cellPadding="0">
                                <tbody>
                                    { envelope.map((file, i) => this.renderDocument(file, i, true)) }
                                </tbody>
                            </table>
                        </Collapse>
                    </td>
                </tr>
            </React.Fragment>
        )
    }

    render() {
        const { classes, document_tree } = this.props

        return (
            document_tree &&
                <div className="file-browser">
                    <table cellSpacing="0" cellPadding="0" className="border-override">
                        <thead>
                            <tr>
                                <th width="50%">Folder / File</th>
                                <th width="20%">Created</th>
                                <th width="20%">Category</th>
                                <th width="10%" className="action-cell"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                document_tree.map((item, index) => {
                                    return (
                                        (item.type === 'folder' && this.renderDocumentFolder(item, index) || item.type === 'file' && this.renderDocument(item, index, false) || item.type === 'envelope' && this.renderEnvelope(item, index))
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            
        )
    }
}

// define the prop types
FileBrowser.propTypes = {

}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        //docSignStatus: state.documentsState.docSignStatus,
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {

    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(FileBrowser))



// WEBPACK FOOTER //
// ./src/components/FileBrowser/index.js